import Vue from 'vue';
import Router from 'vue-router';
import wait from '@/wait'
import store from "@/store";
import config from "@/config";
import propertiesDev from "./env/dev";
import propertiesProd from "./env/prod";
Vue.use(Router)

const now_env = (process.env.NODE_ENV != "production") ? propertiesDev : propertiesProd;

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: now_env
})

router.beforeEach((to, from, next) => { // evitar que puedan ingresar a rutas no autorizadas
  wait.start("loading.everything");
  if (to.matched.some(record => record.meta.secure)) {
    if (store.getters.billingInfo.email !== undefined) {
      next()
      return
    }
    window.location = config.url.error;
  } else {
    next()
  }
})

router.afterEach(() => {
  wait.end("loading.everything");
})

export default router;